import React, { useState, useEffect } from 'react';

import './styles.scss';

interface IProps {
    children: any
}

const InputPasswordShow = ({ children }: IProps) => {
    const [passwordShown, setPasswordShown] = useState(false);

    useEffect(handleChangeInput, [passwordShown, children]);

    function handleChangeInput() {
        try {
            children[0].ref.current.type = passwordShown ? "text" : "password"
        } catch { }
    }

    const togglePasswordVisiblity = () => {

        setPasswordShown(!passwordShown);
    };

    return (
        <div className="InputPasswordShow">
            {children}
            <i className={`fas fa-eye ${passwordShown && 'active'}`}
                onClick={togglePasswordVisiblity}
            ></i>
        </div>
    );
};

export default InputPasswordShow;